import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PagenotfoundComponent } from './template/components/pagenotfound/pagenotfound.component';
import { PageforbiddenComponent } from './template/components/pageforbidden/pageforbidden.component';
import { PagesystemerrorComponent } from './template/components/pagesystemerror/pagesystemerror.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', canActivate: [AuthGuard], component: HomeComponent },
  {
    path: 'users', canActivate: [AuthGuard],
    loadChildren: () => import('./users/user.module').then(m => m.UsersModule)
  },
  { path: 'survey', canActivate: [AuthGuard], 
   loadChildren: () => import('./survey/survey.module').then(m => m.SurveyModule) 
  },
  { path: 'cliente', canActivate: [AuthGuard], 
   loadChildren: () => import('./cliente/cliente.module').then(m => m.ClienteModule) 
  },
  {
    path: 'organizational-structure', canActivate: [AuthGuard],
    loadChildren: () => import('./orgstr/orgstr.module').then(m => m.OrgstrModule)
  },
  { path: 'auth', component: AuthCallbackComponent},
  { path: 'unauthorized',  component: PageforbiddenComponent },
  { path: '403',  component: PageforbiddenComponent },
  { path: '404',  component: PagenotfoundComponent },
  { path: '500',  component: PagesystemerrorComponent },
  { path: '**',  component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
